import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { API_THEME_URL } from '../../connection.data';
import { Theme, themes } from '../../_config/theme.config'
import { BasicService } from './basic.service';

const DEFAULT_THEME = 'DEFAULT';

@Injectable()
export class ThemeService extends BasicService{
    currentTheme$ = new BehaviorSubject<Theme>(null);
    
    constructor(http: HttpClient){
        super(http);
        this.baseUrl = API_THEME_URL;
    }

    getTheme(themeName: string): Theme{
        return themes[themeName.toUpperCase()];
    }

    getDefaultTheme(): Theme{
        return themes[DEFAULT_THEME];
    }

    setCurrentTheme(theme: Theme){
        this.currentTheme$.next(theme);
    }
}